<div class="p-d-flex p-flex-wrap p-ai-center flex-container-center" id="caption-template">
	<!-- Left Side -->
	<div id="left-caption" class="p-d-flex p-ai-center">
		<p-message *ngIf="pollBased && lastUpdate" [severity]="lastUpdate.success ? 'info' : 'error'"
			styleClass="last-refresh p-d-none p-d-md-block"
			text="Last Refresh: {{(lastUpdate.date | date: lastUpdateFormatString)}}">
		</p-message>

		<p-message *ngIf="!pollBased" severity="info" styleClass="last-refresh p-d-none p-d-md-block" [text]="notesMessage">
		</p-message>

		<i *ngIf="hoverSupported" class="pi pi-info-circle p-d-md-none p-mx-2" id="caption-info"
			pTooltip="{{pollBased && lastUpdate ? 'Last Refresh: ' + (lastUpdate.date | date:'MM/dd/yyyy HH:mm:ss') : notesMessage}}">
		</i>

		<ng-container *ngIf="!hoverSupported">
			<p-overlayPanel #lr appendTo="body">
				<ng-template pTemplate>
					{{pollBased && lastUpdate ? 'Last Refresh: ' + (lastUpdate.date | date:'MM/dd/yyyy HH:mm:ss') : notesMessage}}
				</ng-template>
			</p-overlayPanel>

			<button pButton icon="pi pi-info-circle" (click)="lr.toggle($event)"
				class="p-button-rounded p-button-secondary p-button-text caption-button p-d-md-none">
			</button>
		</ng-container>

		<button pButton pRipple icon="pi pi-cog" (click)="actions.toggle($event)" pTooltip="Table Options"
			class="p-button-rounded p-button-secondary p-button-text caption-button p-ml-md-3 p-mr-md-6">
		</button>

		<p-overlayPanel #actions appendTo="body">
			<ng-template pTemplate>
				<div *ngIf="sortMode && showVerticalView">
					<div pSortableColumn="timeframe" class="p-field-checkbox">
						<p-sortIcon field="timeframe"></p-sortIcon>
						<label>Sort By Timeframe</label>
					</div>

					<div *ngFor="let column of columnKeys">
						<div *ngIf="column.show && (column.field == 'updatedBy' || column.field == 'createdBy')" [pSortableColumn]="column.field" class="p-field-checkbox">
							<p-sortIcon [field]="column.field"></p-sortIcon>
							<label>Sort By {{column.header}}</label>
						</div>
						
						<div *ngIf="column.show && column.field == 'priority'" [pSortableColumn]="column.field" class="p-field-checkbox">
							<p-sortIcon field="maxPriority"></p-sortIcon>
							<label>Sort By {{column.header}}</label>
						</div>
					</div>

					<p-divider styleClass="p-mt-4"></p-divider>
				</div>

				<div *ngIf="showVerticalView">
					<div class="p-field-checkbox" [title]="turnoverTooltip">
						<p-checkbox [binary]="true" [(ngModel)]="turnoverFilter" (ngModelChange)="onTurnoverFilterChanged()" 
							class="checkbox-override" label="Turnover Notes Only">
						</p-checkbox>
					</div>

					<p-divider styleClass="p-mt-4"></p-divider>
				</div>

				<div *ngFor="let column of columnKeys">
					<div *ngIf="column.field != 'note'" class="p-field-checkbox">
						<p-checkbox [binary]="true" [(ngModel)]="column.show" (ngModelChange)="onColumnToggled()" class="checkbox-override" label="Show {{column.header}}"></p-checkbox>
					</div>
				</div>

				<button pButton class="p-button-link p-d-block" label="Show Default Columns" (click)="onShowDefaultColumnsClicked()"></button>

				<p-divider styleClass="p-mt-2"></p-divider>

				<ng-container *ngIf="pollBased">
					<div class="p-field-checkbox">
						<p-checkbox [binary]="true" [(ngModel)]="enableAutoScroll" class="checkbox-override" label="Return To Top After Inactivity"></p-checkbox>
					</div>

					<p-divider></p-divider>
				</ng-container>

				<h5 class="p-mt-3">Default Note Expansion</h5>

				<div class="p-formgroup-inline">
					<div class="p-field-checkbox p-mb-2">
						<p-radioButton [(ngModel)]="defaultToAbridged" [value]="true" inputId="collapsed"></p-radioButton>
						<label for="collapsed">Collapsed</label>
					</div>
					
					<div class="p-field-checkbox p-mb-2">
						<p-radioButton [(ngModel)]="defaultToAbridged" [value]="false" inputId="expanded"></p-radioButton>
						<label for="expanded">Expanded</label>
					</div>
				</div>

				<button pButton class="p-button-link p-d-block" label="▼ Expand All Content"
						(click)="onExpandCollapseContentClicked(true)">
				</button>

				<button pButton class="p-button-link p-d-block p-mb-1" label="▲ Collapse All Content"
						(click)="onExpandCollapseContentClicked(false)">
				</button>

				<ng-container *ngIf="useNoteActions">
					<p-divider styleClass="p-my-0"></p-divider>

					<p-overlayPanel #buttonHelp appendTo="body">
						<ng-template pTemplate>
							<ng-container *ngIf="hoverSupported">
								'Hover' will hide the note action buttons until you hover over the note.<br>
							</ng-container>
							
							'Visible' will always show the note action buttons.<br>
							'Disabled' will hide the note action buttons.<br>
						</ng-template>
					</p-overlayPanel>

					<button pButton icon="pi pi-question-circle" (click)="buttonHelp.toggle($event)" iconPos="right"
							class="p-button-rounded p-button-secondary p-button-text p-m-1" label="Show Note Actions">
					</button>

					<p-selectButton [options]="actionButtonOptions" optionLabel="label" optionValue="value" [(ngModel)]="buttonState"></p-selectButton>
				</ng-container>

				<p-divider styleClass="p-mb-1"></p-divider>

				<button pButton icon="pi pi-question-circle" (click)="viewHelp.toggle($event)" iconPos="right"
					class="p-button-rounded p-button-secondary p-button-text p-m-1" label="View Styles">
				</button>

				<p-overlayPanel #viewHelp appendTo="body">
					<ng-template pTemplate>
						The Auto choice will swap between card and table views based on screen size.
					</ng-template>
				</p-overlayPanel>
				
				<p-selectButton [options]="viewSelectionOptions" [(ngModel)]="viewSelection" (ngModelChange)="saveViewSelection()"></p-selectButton>
			</ng-template>
		</p-overlayPanel>
	</div>

	<!-- Middle -->
	<div id="middle-caption">
		<button pButton pRipple icon="pi pi-arrow-up" class="p-button-raised p-button-sm p-button-rounded"
				[disabled]="scrollTop <= 0" (click)="scrollToTop()" pTooltip="Scroll to Top">
		</button>

		<p-dropdown *ngIf="enableReportFiltering" [disabled]="!reportFilters || !reportFilters.length"
					id="report-filter" placeholder="Filter By Report" class="p-ml-3"
					[options]="reportFilters" [(ngModel)]="activeNoteFilterReportId" (onChange)="onReportFilterChanged()"
					optionLabel="name" optionValue="id" [showClear]="true">
		</p-dropdown>
	</div>

	<!-- Right Side -->
	<div id="right-caption" class="p-d-flex p-ai-center p-jc-end">
		<i id="spinner" *ngIf="!pollBased && loading" class="pi pi-spin pi-spinner p-mx-3"></i>

		<button pButton pRipple icon="pi pi-download" (click)="showExportDialog = true"
			[pTooltip]="'Download Visible Notes to PDF' + (downloadCSV ? ' or CSV' : '')"
			class="p-button-rounded p-button-secondary p-button-text caption-button p-mr-md-3">
		</button>

		<lb-export-dialog [(showExportDialog)]="showExportDialog" [exportMessage]="exportMessage" 
			[loading]="loading" [showCSVOption]="!!downloadCSV"
			(exportToPDFClicked)="onExportToPDFClicked($event)"
			(exportToCSVClicked)="downloadCSV!($event)">
		</lb-export-dialog>

		<p-button (click)="maximized = !maximized" *ngIf="showMaximizeButton"
				  [icon]="'pi ' + ((maximized) ? 'pi-window-minimize' : 'pi-window-maximize')"
				  [pTooltip]="maximized ? 'Restore Table Size' : 'Maximize Table'"
				  [styleClass]="'p-button-rounded ' + (maximized ? 'p-button-primary' : 'p-button-secondary p-button-outlined')">
		</p-button>

		<button *ngIf="!pollBased && loading" pButton pRipple (click)="onCancelQueryClicked()" pTooltip="Stop Note Search"
				icon="pi pi-times" class="p-button-rounded p-button-danger">
		</button>

		<button *ngIf="!pollBased && !loading" pButton pRipple (click)="onRefreshQueryClicked()" pTooltip="Refresh Notes"
				icon="pi pi-refresh" class="p-button-rounded">
		</button>
	</div>
</div>